import EventBus from "../../../../util/EventBus";
import withNavigate from "../../../../util/useNavigate";
import Applet from "../../Applet";
import EnlilDetailDialog from "../../../../components/EnlilDetailDialog";

class BillConfigurationFormApplet extends Applet {
    state = {
        Name: "BillConfigurationFormApplet",
        Actions: {
            View: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "UserName",
                            },
                            {
                                id: "Password",
                            },
                            {
                                id: "OrganizationID",
                            },
                            {
                                id: "DeveloperKey",
                            },
                            {
                                id: "V2APIUrl",
                            },
                            {
                                id: "V3APIUrl",
                            }
                        ]
                    }
                ]
            },
            New: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "UserName",
                            },
                            {
                                id: "Password",
                            },
                            {
                                id: "OrganizationID",
                            },
                            {
                                id: "DeveloperKey",
                            },
                            {
                                id: "V2APIUrl",
                            },
                            {
                                id: "V3APIUrl",
                            }
                        ]
                    }
                ]
            },
            Edit: {
                Groups: [
                    {
                        "identifier": "group1",
                        "type": "standard",
                        "selector": null,
                        "characteristics": [],
                        "membership": [
                            {
                                id: "UserName",
                            },
                            {
                                id: "Password",
                            },
                            {
                                id: "OrganizationID",
                            },
                            {
                                id: "DeveloperKey",
                            },
                            {
                                id: "V2APIUrl",
                            },
                            {
                                id: "V3APIUrl",
                            }
                        ]
                    }
                ]
            }
        },
        Layout: {
            totalWidth: "36em",
        },
        Controls: {
            UserName: {
                id: "UserName",
                enterpriseComponentAttribute: "UserName",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                    {
                        validator: "No Special Characters",
                        value: null,
                        errorText: "Field must not have special characters.",
                    },
                    {
                        validator: "No Leading Spaces",
                        value: null,
                        errorText: "Field must not have leading spaces.",
                    },
                    {
                        validator: "No Trailing Spaces",
                        value: null,
                        errorText: "Field must not have trailing spaces.",
                    },
                    {
                        validator: "Not All Spaces",
                        value: null,
                        errorText: "Field must not have all spaces.",
                    },

                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "User Name",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            Password: {
                id: "Password",
                enterpriseComponentAttribute: "Password",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                type: "Password",
                requiresConfirmation: false,
                errors: [],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Password",
                    margin: "dense",
                },
                ip: {}
            },
            OrganizationID: {
                id: "OrganizationID",
                enterpriseComponentAttribute: "OrganizationID",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                    {
                        validator: "No Special Characters",
                        value: null,
                        errorText: "Field must not have special characters.",
                    },
                    {
                        validator: "No Leading Spaces",
                        value: null,
                        errorText: "Field must not have leading spaces.",
                    },
                    {
                        validator: "No Trailing Spaces",
                        value: null,
                        errorText: "Field must not have trailing spaces.",
                    },
                    {
                        validator: "Not All Spaces",
                        value: null,
                        errorText: "Field must not have all spaces.",
                    },

                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Organization ID",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            DeveloperKey: {
                id: "DeveloperKey",
                enterpriseComponentAttribute: "DeveloperKey",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                    {
                        validator: "No Special Characters",
                        value: null,
                        errorText: "Field must not have special characters.",
                    },
                    {
                        validator: "No Leading Spaces",
                        value: null,
                        errorText: "Field must not have leading spaces.",
                    },
                    {
                        validator: "No Trailing Spaces",
                        value: null,
                        errorText: "Field must not have trailing spaces.",
                    },

                    {
                        validator: "Not All Spaces",
                        value: null,
                        errorText: "Field must not have all spaces.",
                    },

                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "Developer Key",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            V2APIUrl: {
                id: "V2APIUrl",
                enterpriseComponentAttribute: "V2APIUrl",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                    {
                        validator: "No Leading Spaces",
                        value: null,
                        errorText: "Field must not have leading spaces.",
                    },
                    {
                        validator: "No Trailing Spaces",
                        value: null,
                        errorText: "Field must not have trailing spaces.",
                    },
                    {
                        validator: "Not All Spaces",
                        value: null,
                        errorText: "Field must not have all spaces.",
                    },

                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "V2 API Url",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            V3APIUrl: {
                id: "V3APIUrl",
                enterpriseComponentAttribute: "V3APIUrl",
                placement: {
                    "View": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Edit": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "New": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                    "Delete": {
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    },
                },
                errors: [
                    {
                        validator: "No Leading Spaces",
                        value: null,
                        errorText: "Field must not have leading spaces.",
                    },
                    {
                        validator: "No Trailing Spaces",
                        value: null,
                        errorText: "Field must not have trailing spaces.",
                    },
                    {
                        validator: "Not All Spaces",
                        value: null,
                        errorText: "Field must not have all spaces.",
                    },

                ],
                csp: {
                    autoFocus: false,
                    multiline: false,
                    placeholder: null,
                    label: "V3 API Url",
                    margin: "dense",
                    disabled: false,
                },
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
        },
    };

    cancel() {
        super.cancel();

        EventBus.components.emit("bill-configuration-form-applet-cancel");
    };

    setAction(action) {
        super.setAction(action);

        if (action === "Save Completed") {
            EventBus.components.emit("bill-configuration-form-applet-save");
        }
    };

    render() {
        return <EnlilDetailDialog applet={this}
                                layout={this.state.Layout}
                                controls={this.state.Controls}
                                actions={this.state.Actions}
                                title="Bill.com Integration Configuration"
                                enterpriseComponent={this.getEnterpriseComponent()}
                                action={this.props.defaultAction}
                                errorReportingMethod="RealTime" />;
    }
}

export default withNavigate(BillConfigurationFormApplet);
